import { useCallback, useState } from "react";

export interface OccupancyState {
  adults: number;
  juniors: number;
  children: number;
  babies: number;
}

export interface NumericOption {
  value: number;
  label: string;
}

export function useOccupancyForm() {
  const [occupancy, setOccupancy] = useState<OccupancyState>({
    adults: 2,
    juniors: 0,
    children: 0,
    babies: 0,
  });
  const [childrenAges, setChildrenAges] = useState<(number | null)[]>([]);

  const stepOccupancy = useCallback((key: keyof OccupancyState, delta: number, max: number) => {
    setOccupancy(current => {
      const next = Math.min(Math.max(current[key] + delta, 0), max);
      return { ...current, [key]: next };
    });
  }, []);

  const stepChildrenCount = useCallback((delta: number, max: number) => {
    setChildrenAges(current => {
      const next = Math.min(Math.max(current.length + delta, 0), max);
      const ages = current.slice(0, next);
      while (ages.length < next) ages.push(null);
      return ages;
    });
  }, []);

  const changeChildAge = useCallback((index: number, option: NumericOption | null) => {
    setChildrenAges(current => {
      const next = [...current];
      next[index] = option?.value ?? null;
      return next;
    });
  }, []);

  return {
    occupancy,
    childrenAges,
    stepOccupancy,
    stepChildrenCount,
    changeChildAge,
  };
}

export function rangeOptions(min: number, max: number): NumericOption[] {
  const options: NumericOption[] = [];
  for (let index = min; index <= max; index++) {
    options.push({ value: index, label: String(index) });
  }
  return options;
}
